import { Component, Input, OnInit } from '@angular/core';
import { ViewService } from 'src/app/modules/realtor/components/view/view.service';


@Component({
    selector: 'report',
    templateUrl: './report.component.html',
    styleUrls: ['./report.component.scss']
})
export class ReportComponent implements OnInit {

    @Input() info : any;

    active = false;

    constructor( 
      protected vs: ViewService
    ){

    }

    ngOnInit(){

      this.active = true;//[5,6].indexOf(parseInt(this.info.owner.perfilId)) > -1;
    }

    async callback(data:any) { 
        data.data.modal = {
          subject : 'problem',
          message : '('+this.info.owner.personName+' - '+this.info.title+')'
        };
        this.vs.setCallback(data);
    }

} 